import { bootstrap } from './bootstrap';

import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { loadableReady } from '@loadable/component';
import { createRoot } from 'react-dom/client';

import App from 'app/shared/pages/App';
import configureStore from 'app/shared/flux/configureStore';
import setupRouting from 'app/client/utils/setupRouting';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';

import '@zillow/constellation-fonts/zillow-fonts.css';

bootstrap.register();

const initialState = window.__INITIAL_STATE__;

const { store, history } = configureStore(initialState, createBrowserHistory());
window.store = store;
window.browserHistory = history;

setupRouting();

const AppRoot = (
  <RpErrorBoundary>
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </RpErrorBoundary>
);

loadableReady(() => {
  const container = document.getElementById('app-root');
  const root = createRoot(container);

  root.render(AppRoot);
});
